export default {
    screenSM: '(min-width: 640px)',
}
